// @flow
export default function invoiceUrl(transactionId: string) {
  return `/invoices/${transactionId}`
}

export function invoicesUrl() {
  return `/invoices`
}
